import * as React from "react";
import { useScreenSize } from "./useScreenSize";
import { styled } from "@mui/material";

//region [[ Styles ]]
const DesktopOnlyView = styled("div")({});
//endregion [[ Styles ]]

//region [[ Props ]]

export interface DesktopOnlyProps {
  children?: JSX.Element | JSX.Element[];
  className?: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]
/***
 * This Higher Order Component wrappes mobile-only content
 * @param props
 * @constructor
 */
export const DesktopOnly = React.memo(({ ...props }: DesktopOnlyProps) => {
  const { isMobile } = useScreenSize();
  if (isMobile) return null;
  return (
    <DesktopOnlyView className={props.className}>
      {props.children}
    </DesktopOnlyView>
  );
});
